var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.2824;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2824;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D2D2D2;}\n\t.st5{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.4,102.1c-19.1,0-38.5-0.8-56.7-5.8c-17.8-5-34.2-14.6-48.8-25.7c-9.6-7.2-18.3-13-30.7-12.1 C62,59.1,50.4,63.7,41,71.5c-15.8,13.7-13.4,39.3-7.1,57.3c9.5,27.1,38.4,45.9,62.9,58.2c28.4,14.2,59.5,22.4,90.8,27.1 c27.4,4.2,62.6,7.2,86.3-10.7c21.8-16.4,27.8-54,22.4-79.3c-1.3-7.5-5.3-14.3-11.2-19c-15.3-11.2-38.2-3.7-55.4-3.3 C223.4,101.9,216.9,102.1,210.4,102.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.7,258.5c46.3,0,83.8-2.3,83.8-5.2c0-2.9-37.5-5.2-83.8-5.2s-83.8,2.3-83.8,5.2 C79.9,256.2,117.4,258.5,163.7,258.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.9,9c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2C211.6,8,212.7,9,213.9,9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.6,199.8c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C66.4,198.8,67.4,199.8,68.6,199.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.5,7.7c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C99.3,6.7,100.3,7.7,101.5,7.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.2,91.5c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C276.9,90.5,277.9,91.5,279.2,91.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.1,215.7v9.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.1,220.6h9.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.6,48.7v9.8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.7,53.6h9.8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.8,34.9v9.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.9,39.8h9.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.3,108.5c16.7,0,30.2-13.5,30.2-30.2c0-16.7-13.5-30.2-30.2-30.2c-16.7,0-30.2,13.5-30.2,30.2 C55.1,95,68.6,108.5,85.3,108.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.3,100.3c12.1,0,22-9.8,22-22s-9.8-22-22-22s-22,9.8-22,22S73.1,100.3,85.3,100.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.7,92.5L84.5,89c-1.9,0.1-3.7-0.4-5.3-1.3l0.7-2.3c1.5,0.9,3.2,1.4,5,1.3c2.4,0,4-1.6,3.9-3.5 c-0.1-2-1.5-3-4-3.9c-3.6-1.2-5.8-2.7-5.9-5.7c0-1.4,0.5-2.8,1.4-3.8c0.9-1.1,2.2-1.7,3.6-1.9l-0.1-3.5h2.1l0.1,3.3 c1.6-0.1,3.2,0.3,4.6,1L89.8,71c-1.3-0.7-2.8-1.1-4.4-1c-2.6,0.1-3.6,1.7-3.5,3.1c0,1.8,1.4,2.6,4.4,3.7c3.6,1.3,5.4,3,5.6,6.1 c0,1.5-0.5,2.9-1.4,4c-1,1.1-2.3,1.8-3.8,2l0.1,3.6L84.7,92.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.4,175.1l-112,28.1c-2.2,0.6-4.5,0.6-6.8,0.1c-2.2-0.5-4.3-1.5-6.1-2.9c-1.8-1.4-3.3-3.2-4.3-5.3 c-1-2.1-1.5-4.3-1.5-6.6V67.8l126.4-31.7c1.3-0.3,2.7-0.4,4-0.1c1.3,0.3,2.5,0.9,3.6,1.7c1.1,0.8,1.9,1.9,2.5,3.1 c0.6,1.2,0.9,2.5,0.9,3.9v121.9c0,2-0.7,3.9-1.9,5.4C233,173.6,231.3,174.7,229.4,175.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.7,68.6h158.1c1.2,0,2.3,0.2,3.4,0.7c1.1,0.4,2,1.1,2.9,1.9c0.8,0.8,1.5,1.8,1.9,2.9 c0.4,1.1,0.7,2.2,0.7,3.4v122.5c0,1.2-0.2,2.3-0.7,3.4c-0.4,1.1-1.1,2-1.9,2.9c-0.8,0.8-1.8,1.5-2.9,1.9c-1.1,0.4-2.2,0.7-3.4,0.7 H109.4c-2.8,0-5.5-1.1-7.5-3.1c-2-2-3.1-4.7-3.1-7.5V68.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.4,148.4c5.4,0,9.8-4.4,9.8-9.8s-4.4-9.8-9.8-9.8c-5.4,0-9.8,4.4-9.8,9.8S238,148.4,243.4,148.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWallet);
export default __webpack_public_path__ + "static/media/no-wallet.430526f1ec2d4d3f78a0c9eda270cc9f.svg";
export { ForwardRef as ReactComponent };